var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWorkspace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.664,
    height: 25,
    viewBox: "0 0 26.664 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.43)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-190.972 -985.526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.323,991.019H194.518l-.488-2.311,13.232-2.682Z",
    transform: "translate(-0.593)",
    fill: "none",
    stroke: "#c7c6d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.134,988.27s-.8-1.755-1.2-1.755H192.2a.729.729,0,0,0-.726.731v14.642a.729.729,0,0,0,.726.73h16.194a.729.729,0,0,0,.726-.73V988.812a.729.729,0,0,0-.726-.73h-1.311",
    transform: "translate(0 -0.113)",
    fill: "none",
    stroke: "#c7c6d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.646,
    transform: "translate(191.472 991.019)",
    fill: "none",
    stroke: "#c7c6d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkspace);
export default __webpack_public_path__ + "static/media/icon-workspace.36a14b1142e3358c5b5b07d7d5896544.svg";
export { ForwardRef as ReactComponent };